import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import { useDebounce } from 'react-use';

import {
  Alert,
  Button,
  Breadcrumb,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
} from "react-bootstrap";

import {
  SelectionState,
  IntegratedSelection,
  TreeDataState,
  CustomTreeData,
  EditingState,
} from '@devexpress/dx-react-grid';

import {
  Plugin,
  Template,
  TemplatePlaceholder,
} from '@devexpress/dx-react-core';

import {
  Grid,
  Table,
  TableHeaderRow,
  TableInlineCellEditing,
  TableTreeColumn,
} from '@devexpress/dx-react-grid-bootstrap4';

import useNotif from 'hooks/use-notify-hook';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import natsort from 'hooks/natsort';
import 'assets/css/tree-grid.css';

const getChildRows = (row, rootRows) => {
  const childRows = rootRows.filter(r => r.PARENT_ID === (row ? row.CRITERIA_ID : null));
  return childRows.length ? childRows : null;
};

const getRowId = row => row.CRITERIA_ID;

const EditPropsPanel = props => (
  <Plugin name="EditPropsPanel">
    <Template name="toolbarContent">
      <SelectTextChecker {...props} />
      <TemplatePlaceholder />
      <StartEditActionSelector {...props} />
    </Template>
  </Plugin>
);

// #FOLD_BLOCK
const StartEditActionSelector = (props) => {
  const { defaultAction, changeAction } = props;
  return (
    <div>
      {'Start Edit Action:'}
      &nbsp;
      <select
        defaultValue={defaultAction}
        onChange={e => changeAction(e.target.value)}
        className="dropdown"
      >
        <option value="click">Click</option>
        <option value="doubleClick">Double Click</option>
      </select>
    </div>
  );
};

const SelectTextChecker = (props) => {
  const { isSelectText, changeSelectText } = props;
  return (
    <div
      style={{
        padding: '0em 1em',
      }}
    >
      <label htmlFor="selectTextChecker" className="form-check-label">
        <input
          type="checkbox"
          checked={isSelectText}
          id="selectTextChecker"
          name="selectTextChecker"
          className="form-check-input"
          onChange={e => changeSelectText(e.target.checked)}
        />
        Select Text On Focus
      </label>
    </div>
  );
};

export default function Edit() {

  const history = useHistory();
  const [hasSchedules, setHasSchedules] = useState(true);
  const {instrumentId} = useParams();
  const [swal, setSwal] = useAlert();
  const [notif, setNotif] = useNotif();
  const [name, setName] = useState(``);
  const [standard, setStandard] = useState(-1);
  const [score, setScore] = useState(``);
  const [standards, setStandards] = useState([]);
  const [selection, setSelection] = useState([]);
  const [startEditAction, setStartEditAction] = useState('click');
  const [selectTextOnEditStart, setSelectTextOnEditStart] = useState(true);
  const [rows, setRows] = useState([]);
  const [criteriaid, seCriteriaid] = useState([]);
  const [sheet, setSheet] = useState(``);
  const [docs, setDocs] = useState(``);
  const [tableColumnExtensions] = useState([{columnName: 'name'}]);
  const [columns] = useState([
    {name: 'CRITERIA_CODE', title: 'Bullet'},
    {name: 'CRITERIA_LABEL', title: 'Name'}
  ]);

  const [buttonDelete, setButtonDelete] = useState(false);
  const [buttonSelected, setButtonSelected] = useState(false);
  // const handleDuplicate = async () => {
  //   const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}instruments/10`);
  //   // navigate(`admin/instruments/${data.INSTRUMENT_ID}/edit`);
  //   history.push(`/admin/instruments/10/edit`);
  //   console.log('Test Button');
  //   console.log(data);
  // };

   /**
   * Debouncehr saving on change
   *
   */
  const [, cancelName] = useDebounce(async () => {

    if (!name) return;

    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}instruments/${instrumentId}`,
      { INSTRUMENT_NAME: name },
      { headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
      }
    );

    setNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

    setName(response.data.INSTRUMENT_NAME);

  }, 2000, [name]);


  const commitChanges = async ({ added, changed, deleted }) => {

    let changedRows;

    if (changed) {

      try {

        const id = Object.keys(changed).pop();
        const updatedItem = { ...changed[id] };
        await axios.put(
          `${process.env.REACT_APP_API_HOST}criterias/${id}`,
          updatedItem,
          { headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          }});

        changedRows = rows.map(row => (parseInt(row.CRITERIA_ID) === parseInt(id))
          ? {
            ...row,
            ...updatedItem
          }
          : row
        );

      } catch (error) {
        setSwal({
          type: TYPES.ERROR,
          payload: {
            message: error.toString(),
          }
        });
      }
    }

    if (deleted) {
      const deletedSet = new Set(deleted);
      changedRows = rows.filter(row => !deletedSet.has(row.id));
    }

    setRows(changedRows);

  };


  const handleCriteriaDelete = async () => {

    try {

      const item = rows.find(row => row.CRITERIA_ID === [...selection].pop());
      const onSuccessCallback = async () => {
        const response = await axios.delete(`${process.env.REACT_APP_API_HOST}criterias/${item.CRITERIA_ID}`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          },
        });
        setRows([...rows].filter(row => parseInt(row.CRITERIA_ID) !== parseInt(item.CRITERIA_ID)));
        setSelection([]);
      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure?`,
          message: `You are about to delete "${item.CRITERIA_LABEL}" criteria.`,
          onSuccess: {
            title: `Success`,
            message: `Delete Success`,
            callback: onSuccessCallback,
          }
        }
      });
    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleNewCriteriaDelete = async () => {

    try {
      const onSuccessCallback = async () => {
        console.log(selection)
        let formData = new FormData();
        formData.append('TEST', selection);
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}criteria/new-delete`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          }
        });
        setRows([...rows].filter(row => !selection.includes(parseInt(row.CRITERIA_ID))));
        setSelection([]);
      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure?`,
          message: `You are about to delete selected criteria.`,
          onSuccess: {
            title: `Success`,
            message: `Delete Success`,
            callback: onSuccessCallback,
          }
        }
      });
    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handlePublish = async () => {

    let errorMessage = null;

    switch (true) {
      case !name:
        errorMessage = `Name should not be empty`;
        break;
    }

    if (errorMessage) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          title: `Submit Validation Error.`,
          message: errorMessage,
        }
      });
    }

    try {

      const onSuccessCallback = async () => {
        const response = await axios.put(
          `${process.env.REACT_APP_API_HOST}instruments/${instrumentId}`,
          {INSTRUMENT_STATUS: 'PUBLISHED'},
          {headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`}}
        );

        history.push(`/admin/instruments`);
      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure?`,
          message: `You are about to publish "${standards.find(std => std.STANDARD_ID === standard).STANDARD_NAME} - ${name}" instrument template.`,
          onSuccess: {
            title: `Success`,
            message: `Delete Success`,
            callback: onSuccessCallback,
          }
        }
      });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  };


  const fetchStandard = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}standards`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
        params: {
          all: true,
        }
      });

      setStandards(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }


  const fetchInstrument = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}instruments/${instrumentId}`,
        {
          headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`},
          params: {expand: `score.scoreIndices,criterias,implementations,questions`}
        }
      );

      const {
        INSTRUMENT_NAME,
        FORM_FILE,
        REPORT_FILE,
        STANDARD_ID,
        implementations,
        score,
        criterias,
      } = response.data;

      setHasSchedules(implementations > 1);
      setSheet(FORM_FILE?.split('/').pop() ?? 'Please Choose...');
      setDocs(REPORT_FILE?.split('/').pop() ?? 'Please Choose...');
      setName(INSTRUMENT_NAME);
      setStandard(STANDARD_ID);
      setScore(score);
      setRows([...criterias].sort((a, b) => natsort(a.CRITERIA_CODE, b.CRITERIA_CODE)));
      cancelName();

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {message: error.toString()}
      });
    }
  }

  const handleUploadReport = async ({target}) => {

    if (!report) return;

    try {

      let payload = new FormData();
      payload.append('report', target.files[0]);


      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}instruments/${instrumentId}/upload-docs`,
        payload,
        {headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          "Content-Type": `multipart/form-data; charset=utf-8; boundary="${Math.random().toString().substr(2)});`,
        }}
      );

    setDocs(target.files[0].name);

    setNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {message: error.toString()}
      });
    }
  }

  const handleStandardChange = async ({ target: { value }}) => {

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}instruments/${instrumentId}`,
        { STANDARD_ID: value },
        { headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          },
        }
      );

      setNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

      setStandard(value);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }

  }

  const handleCriteriaCreate = async () => {

    try {

      let payload = {
        INSTRUMENT_ID: instrumentId,
        CRITERIA_LEVEL: 1,
        PARENT_ID: null,
      }

      if (selection.length > 0) {
        payload.PARENT_ID = [...selection].shift();
      }

      const response = await axios.post(`${process.env.REACT_APP_API_HOST}criterias`, payload, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
      });

      setRows([...rows, {
        ...response.data,
        CRITERIA_CODE: `New Bullet`,
        CRITERIA_LABEL: `New Criteria`,
      }]);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleCriteriaDuplicate = async () => {

    try {

      let payload = {
        INSTRUMENT_ID: instrumentId,
        CRITERIA_LEVEL: 1,
        PARENT_ID: null,
      }

      if (selection.length > 0) {
        payload.PARENT_ID = [...selection].shift();
      }

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}criterias`, payload, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        },
      });
      console.log(response);
      // const response_inst = await axios.get(`${process.env.REACT_APP_API_HOST}instrument`, payload, {
      //   headers: {
      //     Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
      //   },
      // });
      let page = response.data._meta.pageCount;
      for (let i=1; i < page+1; i++){
        const responsz = await axios.get(`${process.env.REACT_APP_API_HOST}criterias?page=`+i, payload, {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          },
        });
        responsz.data.items.map((name) => {
          if (name.INSTRUMENT_ID == 11){
            let criteriaId = name.CRITERIA_ID;
            criteriaid.push(criteriaId);
          }
        });
      }
      console.log(criteriaid);

      const responseC = await axios.get(
        `${process.env.REACT_APP_API_HOST}criterias/80`,
        {
          params: {expand: `questions,instrument.score.scoreIndices,instrument.standard,instrument.implementations`},
          headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`}
        },
      );
      console.log(responseC);
      // setRows([...rows, {
      //   ...response.data,
      //   CRITERIA_CODE: `New Bullet`,
      //   CRITERIA_LABEL: `New Criteria`,
      // }]);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleSelectAll = () => {
    let tempList = []
    if(buttonSelected){
      setSelection([])
      setButtonSelected(false)
    }else{
      rows.forEach(data => {
        tempList.push(data.CRITERIA_ID)
      })
      setSelection(tempList)
      setButtonSelected(true)
    }
  }

  const handleSelect = (value) => {
    if(buttonSelected){
      setSelection(value)
    }else{
      setSelection(value.filter(val => !selection.includes(val)))
    }
  }

  useEffect(() => {

    fetchStandard();
    fetchInstrument();

  }, []);

  return (
    <Container fluid>
      {swal}
      {notif}
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => history.push(`/admin/instruments`)}>
          Instruments
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Edit
        </Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col md={12}>
          <Card>
            <Card.Header>
              <Card.Title as="h4">Edit Instrument Form</Card.Title>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={4}>
                  {standards && (
                    <Form.Group>
                      <Form.Label>Standard</Form.Label>
                        <Form.Control
                          defaultValue={-1}
                          value={standard}
                          name="STANDARD_ID"
                          as="select"
                          onChange={handleStandardChange}
                          disabled={hasSchedules}
                        >
                          <option disabled value={-1}>Please Select...</option>
                          {standards.map((standard, key) => (
                            <option key={key} value={standard.STANDARD_ID}>
                              {standard.STANDARD_NAME}
                            </option>
                          ))}
                        </Form.Control>
                    </Form.Group>
                  )}
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      value={name}
                      onChange={({target: {value}}) => setName(value)}
                      disabled={hasSchedules}
                    />
                  </Form.Group>
                  {/* <Form.Group>
                    <Form.Label>Duplicate</Form.Label>
                    <InputGroup className="mb-3">
                    <Button variant="primary" onClick={handleDuplicate}>Duplicate Template</Button>
                    </InputGroup>
                  </Form.Group> */}
                </Col>
                <Col md={4}>
                  {sheet !== 'Please Choose...' && (
                    <Form.Group>
                      <Form.Label>Current Spreadsheet</Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          value={sheet}
                          readOnly={true}
                        />
                        <a href={`${process.env.REACT_APP_API_HOST}instruments/${instrumentId}/download-spreadsheet`}
                          className="btn btn-secondary" id="button-addon2"
                        >
                          Download
                        </a>
                      </InputGroup>
                    </Form.Group>
                  )}
                  <Form.Group>
                    <Form.Label>Report Template</Form.Label>
                    <Form.File
                      id="report-file"
                      custom
                      disabled={hasSchedules}
                      label={docs || 'Choose File'}
                      accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      onChange={handleUploadReport}
                    />
                    <a href={`${process.env.REACT_APP_API_HOST}instruments/${instrumentId}/download-docs`}>Preview</a>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  {score && (
                    <Form.Group>
                      <Form.Label>Scoring Type</Form.Label>
                      <p>{score.SCORE_NAME}</p>
                      <ul>
                        {score.scoreIndices.map((index, key) => (
                          <li key={key}>
                            <b>
                              <span className={`text-${index.SCORE_STATUS === 1 ? `success` : index.SCORE_STATUS === 0 ? `danger` : `info`}`}>
                                {index.SCORE_INDEX} ({index.SCORE_STATUS === 1 ? `Passed` : index.SCORE_STATUS === 0 ? `Failed` : `Not Applicable`})
                              </span>
                            </b>
                          </li>
                        ))}
                      </ul>
                    </Form.Group>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <Card.Header>
              <Card.Title as="h4">Instrument Criteria</Card.Title>
              {/* <Button variant="primary" onClick={handleCriteriaDuplicate}>Duplicate</Button> */}
            </Card.Header>
            <Card.Body>
              {!hasSchedules && (
                buttonSelected?
                <Button onClick={handleSelectAll} >
                  Unselect All
                </Button>:
                <Button onClick={handleSelectAll} >
                  Select All
                </Button>
              )}
              {' '}
              {/* {!hasSchedules && (
                <Button
                  disabled={selection.length === 0}
                  onClick={handleCriteriaDelete}
                  variant="danger">
                    Delete
                </Button>
              )} */}
              <Row>
                {!hasSchedules && (
                  <Col md="2">
                    <h5>Add New</h5>
                    <Button variant="primary" onClick={handleCriteriaCreate}>Group</Button>{`  `}
                    <Button variant="primary" onClick={handleCriteriaCreate} disabled={selection.length === 0}>SubGroup</Button>
                  </Col>
                )}
                <Col md="10">
                  <Grid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowId}
                  >
                    <SelectionState
                      selection={selection}
                      // onSelectionChange={value =>  setSelection(value.filter(val => !selection.includes(val)))}
                      onSelectionChange={value => handleSelect(value)}
                    />
                    <TreeDataState />
                    <CustomTreeData
                      getChildRows={getChildRows}
                    />
                    <IntegratedSelection />
                    {!hasSchedules && <EditingState onCommitChanges={commitChanges} />}

                    <Table
                      columnExtensions={tableColumnExtensions}
                    />
                    <TableHeaderRow />
                    <TableTreeColumn
                      for="CRITERIA_CODE"
                      showSelectionControls
                    />
                    {!hasSchedules && (
                      <>
                        <EditPropsPanel
                          defaultAction={startEditAction}
                          changeAction={setStartEditAction}
                          isSelectText={selectTextOnEditStart}
                          changeSelectText={setSelectTextOnEditStart}
                        />
                        <TableInlineCellEditing
                          startEditAction={startEditAction}
                          selectTextOnEditStart={selectTextOnEditStart}
                        />
                      </>
                    )}
                  </Grid>
                </Col>
              </Row>
              <Row style={{ justifyContent: 'flex-end' }}>
                <Col style={{ width: 'auto', flexGrow: 'unset', flexBasis: 'unset' }}>
                  {!hasSchedules && (
                    <Button
                      disabled={selection.length === 0}
                      onClick={handleNewCriteriaDelete}
                      variant="danger">
                        Delete
                    </Button>
                  )}{' '}
                  <Link to={`/admin/instruments/${instrumentId}/criterias/${[...selection].shift()}/edit`}>
                    <Button
                      disabled={
                        selection.length === 0 || selection.length > 1 ||
                        rows.some(row => row.PARENT_ID === [...selection].shift())
                      }
                      variant="info"
                    >
                      Go To Form
                    </Button>{' '}
                  </Link>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {hasSchedules
        ? <Alert style={{textAlign: 'center'}} variant="info">Evaluation Process has been completed.</Alert>
        : (
          <Row style={{ justifyContent: 'flex-end' }}>
            <Col style={{ width: 'auto', flexGrow: 'unset', flexBasis: 'unset' }}>
              <Button
                disabled={hasSchedules}
                onClick={handlePublish}
                variant="success">
                  Publish
                </Button>{' '}
            </Col>
          </Row>
        )
      }
    </Container>
  )
}
